import { ISabreSegmentState } from "@/core/interfaces/sabreSegmentState.interface";

const sabreSegmentState: ISabreSegmentState = {
  defaultSegmentList: null,
  defaultSegmentStats: null,
};

export default sabreSegmentState;
